import React, { useState } from "react";
import {
  Grow,
  Paper,
  Button,
  MenuItem,
  MenuList,
  ClickAwayListener,
  PopperPlacementType,
  Popper,
} from "@mui/material";
import { useSlate } from "slate-react";

interface IMacroProps {
  id: number;
  label: string;
  value: string;
}

const macroOptionsTerms: IMacroProps[] = [
  { id: 1, label: "PessoaNome", value: "{PessoaNome}" },
  { id: 2, label: "PessoaCPF", value: "{PessoaCPF}" },
  { id: 3, label: "PessoaRNE", value: "{PessoaRNE}" },
  { id: 4, label: "PessoaCNPJ", value: "{PessoaCNPJ}" },
  { id: 5, label: "PessoaIP", value: "{PessoaIP}" },
  { id: 6, label: "EstabelecimentoNome", value: "{EstabelecimentoNome}" },
  { id: 7, label: "DataEHoraAtual", value: "{DataEHoraAtual}" },
];

const macroOptionsOrientation: IMacroProps[] = [
  { id: 1, label: "PessoaNome", value: "{PessoaNome}" },
  { id: 2, label: "PessoaContaEmail", value: "{PessoaContaEmail}" },
  { id: 3, label: "AssinaturaDataEHora", value: "{AssinaturaDataEHora}" },
];

const macroOptionsEmail: IMacroProps[] = [
  { id: 1, label: "AssinaturaToken", value: "{AssinaturaToken}" },
];

interface IProps {
  disabled?: boolean;
  macroType: "Terms" | "Orientation" | "Email";
}

export const MacroButton: React.FC<IProps> = ({
  macroType,
  disabled = false,
}) => {
  const editor = useSlate();

  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [placement, setPlacement] = useState<PopperPlacementType>();

  const handleToggle =
    (newPlacement: PopperPlacementType) =>
    (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
      setOpen((prev) => placement !== newPlacement || !prev);
      setPlacement(newPlacement);
    };

  const handleClose = () => setOpen(false);

  return (
    <>
      <Button
        disableElevation
        disabled={disabled}
        size="small"
        color="primary"
        variant="contained"
        onClick={handleToggle("bottom-start")}
      >
        Macros
      </Button>
      <Popper
        style={{ zIndex: 1 }}
        open={open}
        anchorEl={anchorEl}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList style={{ maxHeight: "200px", overflowY: "auto" }}>
                  {(macroType === "Email"
                    ? macroOptionsEmail
                    : macroType === "Terms"
                    ? macroOptionsTerms
                    : macroOptionsOrientation
                  ).map((option, index) => (
                    <MenuItem
                      key={index}
                      onClick={(event) => {
                        event.preventDefault();
                        editor.insertText(option.value);
                        setOpen(false);
                      }}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};
